<template>
  <span class="beta-badge">
    Beta
  </span>
</template>

<style>
.beta-badge { @apply
  inline-flex
  border
  border-divider
  items-center
  rounded-full
  px-3
  py-0.5
  text-sm
}
</style>
